let CustomStore;

import { post, getById } from ".";
import("devextreme/data/custom_store").then((x) => {
    CustomStore = x.default;
});

export function setupLookupSort(loadOptions, field, desc) {
    var descVal = desc == undefined ? false : desc;
    loadOptions.sort = [{ selector: field, desc: descVal }];
}

export function setupLookupFilter(loadOptions) {
    if (loadOptions.searchExpr == undefined)
        return;

    if (!Array.isArray(loadOptions.searchExpr))
        loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
    else {
        var logicOperator = loadOptions.filterLogicOperator.toLowerCase();

        if (logicOperator !== "or" && logicOperator !== "and")
            throw "Unknown logic operator: " + loadOptions.filterLogicOperator;

        loadOptions.filter = [];

        for (var i = 0; i < loadOptions.searchExpr.length; i++) {
            if (i != 0)
                loadOptions.filter.push(logicOperator);

            loadOptions.filter.push([loadOptions.searchExpr[i], loadOptions.searchOperation, loadOptions.searchValue]);
        }
    }
}

export function addIsActiveCondition(loadOptions, fieldName) {
    if (fieldName == null || fieldName == "")
        return;

    var filter = [fieldName, "=", 1]
    if (isNaN(loadOptions.skip))
        var doNothing = 1;
    else
        loadOptions.filter = loadOptions.filter ? [loadOptions.filter, "and", filter] : filter
}

export function createLookupDataSource(primaryKeyName, repository, sortBy, baseQuery, alterLoadOptionsFunc) {

    var _that = null;
    var _key = null;

    return {
        paginate: true,
        pageSize: 20,
        store: new CustomStore({
            key: primaryKeyName,
            byKey: function (key) {
                if (_key == null || _key != key) {
                    _key = key;
                    _that = getById(repository, key).then(response => response.blo)
                }
                return _that
            },
            load: function (loadOptions) {
                setupLookupFilter(loadOptions);
                if (typeof baseQuery === "string")
                    loadOptions.baseQuery = baseQuery;
                if (typeof sortBy === "string")
                    setupLookupSort(loadOptions, sortBy);
                if (alterLoadOptionsFunc)
                    alterLoadOptionsFunc(loadOptions);
                return post(repository, loadOptions);
            }
        }),
    };
}

export function createLookupDataSourceTextKey(primaryKeyName, repository, sortBy, baseQuery, alterLoadOptionsFunc, displayExpr) {

    var _that = null;
    var _key = null;

    return {
        paginate: true,
        pageSize: 20,
        store: new CustomStore({
            key: primaryKeyName,
            byKey: function (key) {
                var x = {};
                x[primaryKeyName] = -1;
                x[displayExpr] = key;
                return x;
            },
            load: function (loadOptions) {
                setupLookupFilter(loadOptions);
                if (typeof baseQuery === "string")
                    loadOptions.baseQuery = baseQuery;
                if (typeof sortBy === "string")
                    setupLookupSort(loadOptions, sortBy);
                if (alterLoadOptionsFunc)
                    alterLoadOptionsFunc(loadOptions);
                return post(repository, loadOptions);
            }
        }),
    };
}

export function createBrowseDataSource(key, repository, alterLoadOptionsFunc, gridInstance) {
    return {
        store: new CustomStore({
            key,
            load: loadOptions => {
                if (alterLoadOptionsFunc)
                    alterLoadOptionsFunc(loadOptions);

                if (gridInstance) {
                    var x = gridInstance();
                    if (x.dgBrowse) {
                        if (x.dgBrowse.ignoreLoad === true) {

                            loadOptions.filter = [key, "=", -1]
                        }
                    }
                }

                return post(repository, loadOptions)
            }
        })
    };
}

